
import { TimeHorizon } from '../types';

export const defaultDayHorizons: TimeHorizon[] = [
  { id: "d1", label: "1 Day" },
  { id: "d3", label: "3 Days" },
  { id: "d7", label: "7 Days" },
  { id: "d15", label: "15 Days" },
  { id: "d30", label: "30 Days" }
];

export const defaultTimeHorizons: TimeHorizon[] = [
  { id: "h1", label: "1 Month" },
  { id: "h2", label: "2 Months" },
  { id: "h3", label: "3 Months" },
  { id: "h4", label: "6 Months" },
  { id: "h5", label: "12 Months" }
];
